import React from 'react';

interface IMailIconProps {
	size?: string;
	stroke?: string;
}

export const MailIcon = ({ size = '24', stroke }: IMailIconProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none">
			<path
				d="M2 7C2 5.89543 2.89543 5 4 5H19.8095C20.9141 5 21.8095 5.89543 21.8095 7V17C21.8095 18.1046 20.9141 19 19.8095 19H4C2.89543 19 2 18.1046 2 17V7Z"
				stroke={stroke || '#3D3D3D'}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 6.68665L10.9219 13.2746C11.1968 13.4777 11.545 13.5891 11.9048 13.5891C12.2645 13.5891 12.6127 13.4777 12.8876 13.2746L21.8095 6.68665"
				stroke={stroke || '#3D3D3D'}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
